import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { PapsServiceColor } from "config/status";
import { ERequestType } from "generated/graphql";
import styled from "styled-components";

export const EmptyTableContent = styled("h3")<{ color?: string }>`
  padding: 3rem 1rem;
  border-radius: 4px;
  text-align: center;
  margin: 0 auto;
  font-size: 1.4rem;
  font-weight: 400;
  color: ${(p) => p.color || "#959595"};

  .highlighted {
    font-weight: 600;
    color: initial;
  }
`;

export const EmptyText = styled("h3")<{ color?: string }>`
  padding: 1rem 1rem;
  border-radius: 4px;
  text-align: center;
  width: 20%;
  margin: 0 auto;
  font-size: 1rem;
  margin-top: 30px;
  font-weight: bold;
  color: ${(p) => p.color || "#959595"};

  .highlighted {
    font-weight: 600;
    color: initial;
  }
`;

interface StyleProps {
  color?: string;
}

export const REQUEST_COLORS = {
  [ERequestType.Mad]: "#2f80ed",
  [ERequestType.Nt]: "#394fbf",
  [ERequestType.Tr]: "#2ba815",
  [ERequestType.Msg]: "#399ebf",
  ...PapsServiceColor,
};

export const useTableStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    tableCells: {
      "& .MuiTableCell-root:first-child": {
        border: "1.5px solid #E2F4FB",
        borderRight: "none",
        marginTop: "50px",
        borderLeft: ({ color }: StyleProps) => (color ? `4px solid ${REQUEST_COLORS[color]} !important` : "none"),
        borderRadius: "5px 0px 0px 5px",
      },
      "& .MuiTableCell-root:last-child": {
        border: "1.5px solid #E2F4FB",
        borderLeft: "none",
        borderRadius: "0px 5px 5px 0px",
      },
      "& .MuiTableCell-root": {
        border: "1.5px solid #E2F4FB",
        borderLeft: "none",
        borderRight: "none",
        marginTop: 5,
        [theme.breakpoints.down("xs")]: {
          backgroundColor: "#fafcfe",
        },
      },
    },
  })
);
